export const VARIANT_ROUNDED = 'rounded';
export const COLOR_SCHEME_LIGHT = 'light';
